﻿
export function DownloadFile(
    fileName: string,
    content: string | ArrayBuffer | BlobPart,
    mime: string = "text/plain;charset=utf-8"
): void {
    const blob = new Blob([content], { type: mime });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = fileName || "download.txt";

    // Безопасно добавить и удалить элемент
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    URL.revokeObjectURL(url);
}

export function ScrollIntoView(selector: string, mode: number): void {
    let el: Element | null;

    try {
        el = document.querySelector(selector);
    } catch (e) {
        Error("Invalid selector for ScrollIntoView", selector, e);
        return;
    }

    if (!(el instanceof HTMLElement)) return;

    const rect = el.getBoundingClientRect();
    const top = window.scrollY + rect.top;
    const view = window.innerHeight;

    let next = window.scrollY;

    switch (mode) {
        case 1:
            next = top;
            break;
        case 2:
            next = top - view / 2 + rect.height / 2;
            break;
        default:
            if (rect.top >= 0 && rect.bottom <= view) return;
            next = rect.top < 0 ? top : top - view + rect.height;
            break;
    }

    const max = Math.max(0, document.documentElement.scrollHeight - view);
    next = Math.min(Math.max(0, next), max);

    const start = window.scrollY;
    const delta = next - start;

    if (Math.abs(delta) < 1) return;

    const span = Math.max(300, Math.min(900, Math.abs(delta) * 0.6));
    const from = performance.now();
    const ease = (x: number): number =>
        x * x * x * (x * (x * 6 - 15) + 10);

    const tick = (now: number) => {
        const x = Math.min((now - from) / span, 1);

        window.scrollTo({
            top: start + delta * ease(x),
            behavior: "auto"
        });

        if (x < 1) requestAnimationFrame(tick);
    };

    requestAnimationFrame(tick);
}

export function Delay(milliseconds: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, milliseconds));
}

export function Trace(message?: any, ...optionalParams: any[]): void {
    console.log(message, optionalParams);
}

export function Information(message?: any, ...optionalParams: any[]): void {
    console.log(message, optionalParams);
}

export function Error(message?: any, ...optionalParams: any[]): void {
    console.error(message, optionalParams);
}

export function Warning(message?: any, ...optionalParams: any[]): void {
    console.warn(message, optionalParams);
}

export function Catch(action: Function | Promise<any> | null): any | Promise<any> | null {
    if (!action) return null;
    if (action instanceof Promise) {
        return action.catch(e => Error(e));
    } else {
        try {
            return action();
        } catch (e) {
            Error(e);
            return null;
        }
    }
}
